// @flow
import React from 'react';
import Button from 'components/common/Button';
import { numberWithCommas, imageURL } from 'lib/common';
import { isBrowser } from 'react-device-detect';
import './CartTemplate.scss';

type Props = {
  cart: any,
  allCheckedCart: () => void,
  updateCheckedCart: (index: number) => void,
  updateItemCart: (index: number, id: string, event: any) => void,
  deleteItemCart: (id: string) => void,
  deleteItemCheckedCart: () => void,
  emptyCart: () => void,
  goProduct: (id: string) => void,
  onOrder: () => void,
  onOffer: () => void,
  onShopping: () => void,
};

const CartTemplate = (props: Props) => (
  <div className="cart-template">
    <div className="cart-container">
      <div className="cart-header">
        <div className="cart-title-section">
          <h2>
            <button
              className="back-button"
              onClick={() => window.history.back()}
              aria-label="뒤로가기"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
            </button>
            장바구니
          </h2>
          <span className="cart-count">{props.cart.items.length}개 상품</span>
        </div>
        <div className="cart-actions desktop-only">
          <button
            className="delete-selected-btn"
            onClick={props.removeSelectedCart}
            disabled={!props.cart.items.some(item => item.checked)}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2" />
              <line x1="10" y1="11" x2="10" y2="17" />
              <line x1="14" y1="11" x2="14" y2="17" />
            </svg>
            선택삭제
          </button>
        </div>
      </div>

      <div className="cart-content">
        {/* 전체선택 컨트롤 */}
        <div className="select-all-section mobile-only">
          <label className="select-all-checkbox" htmlFor="select-all">
            <input
              id="select-all"
              name="allChecked"
              type="checkbox"
              checked={props.cart.allChecked}
              onChange={props.allCheckedCart}
            />
            <span className="checkmark"></span>
            <span className="select-all-text">
              {props.cart.items.filter(item => item.checked).length > 0
                ? `${props.cart.items.filter(item => item.checked).length}개선택`
                : '전체선택'}
            </span>
          </label>
          <div className="cart-actions">
            <button
              className="delete-selected-btn"
              onClick={props.removeSelectedCart}
              disabled={!props.cart.items.some(item => item.checked)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c0 1 1 2 2 2v2" />
                <line x1="10" y1="11" x2="10" y2="17" />
                <line x1="14" y1="11" x2="14" y2="17" />
              </svg>
              선택삭제
            </button>
          </div>
        </div>

        {/* 데스크톱 테이블 */}
        <div className="cart-table-container desktop-only">
          <table className="cart-table">
            <thead>
              <tr>
                <th className="col-checkbox">
                  <label className="header-select-all-checkbox" htmlFor="header-select-all">
                    <input
                      id="header-select-all"
                      name="allChecked"
                      type="checkbox"
                      checked={props.cart.allChecked}
                      onChange={props.allCheckedCart}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th className="col-image">이미지</th>
                <th className="col-product">상품정보</th>
                <th className="col-unit-price">단가</th>
                <th className="col-quantity">수량</th>
                <th className="col-price">가격</th>
                <th className="col-actions">삭제</th>
              </tr>
            </thead>
            <tbody>
              {!props.cart.items.length ? (
                <tr className="empty-cart">
                  <td colSpan="7">
                    <p>장바구니에 상품이 하나도 없습니다.</p>
                  </td>
                </tr>
              ) : (
                props.cart.items.map((item, index) => (
                  <tr key={item.id} className="cart-item">
                    <td className="cart-item-checkbox">
                      <label className="item-checkbox" htmlFor={`item-checkbox-${index}`}>
                        <input
                          id={`item-checkbox-${index}`}
                          name="isGoing"
                          type="checkbox"
                          checked={item.checked}
                          onChange={() => props.updateCheckedCart(index)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td className="cart-item-thumbnail-container">
                      <div className="product-image">
                        <a
                          onClick={() => props.goProduct(item.product.id)}
                          className="cart-item-name-link"
                        >
                          <img
                            src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                            className="cart-item-thumbnail"
                            alt="thumbnail"
                          />
                        </a>
                      </div>
                    </td>
                    <td className="cart-item-name">
                      <div className="cart-item-summary">
                        <h3 className="product-name">
                          {item.product ? (
                            <a
                              onClick={() => props.goProduct(item.product.id)}
                              className="cart-item-name-link"
                            >
                              {item.product.name}
                            </a>
                          ) : (
                            <span className="deleted-product">삭제된 상품</span>
                          )}
                        </h3>
                        <div className="product-details">
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">카탈로그 번호:</span>
                              <span className="detail-value">{item.product_price.part_number}</span>
                            </div>
                          )}
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">설명:</span>
                              <span className="detail-value">{item.product_price.description}</span>
                            </div>
                          )}
                          {item.product_price && (
                            <div className="detail-item">
                              <span className="detail-label">단위:</span>
                              <span className="detail-value">{item.product_price.unit}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    {item.price ? (
                      <td className="cart-item-unit-price">
                        {item.price.sale.raw !== item.price.original.raw && (
                          <span className="cart-item-compare-price">
                            {numberWithCommas(item.price.original.raw)}원
                          </span>
                        )}
                        <span className="cart-item-sale-price">
                          {numberWithCommas(item.price.sale.raw)}원
                        </span>
                      </td>
                    ) : (
                      <td className="cart-item-unit-price">
                        <span className="cart-item-sale-price">
                          {numberWithCommas(item.product_price.price)}원
                        </span>
                      </td>
                    )}
                    <td className="cart-item-quantity">
                      <div className="quantity-control">
                        <button
                          type="button"
                          className="quantity-btn minus"
                          onClick={() => {
                            if (item.quantity > 1) {
                              const event = { target: { value: item.quantity - 1 } };
                              props.updateItemCart(index, item.id, event);
                            }
                          }}
                          disabled={item.quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
                            <path d="M0 1H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                        <input
                          name="itemQuantity"
                          min="1"
                          onChange={event => props.updateItemCart(index, item.id, event)}
                          value={item.quantity}
                          className="quantity-input"
                          required
                          type="text"
                          pattern="[1-9]*"
                        />
                        <button
                          type="button"
                          className="quantity-btn plus"
                          onClick={() => {
                            const event = { target: { value: item.quantity + 1 } };
                            props.updateItemCart(index, item.id, event);
                          }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 0V12M0 6H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                      </div>
                    </td>
                    <td className="cart-item-price">
                      {item.product_price.price !== item.product_price.original_price && (
                        <span className="cart-item-compare-price">
                          {numberWithCommas(item.quantity * item.product_price.original_price)}원
                        </span>
                      )}
                      <span className="cart-item-sale-price">
                        {numberWithCommas(item.quantity * item.product_price.price)}원
                      </span>
                    </td>
                    <td className="action-delete-cart-item">
                      <button
                        className="delete-cart-item"
                        onClick={() => props.deleteItemCart(item.id)}
                        type="button"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M12 4L4 12M4 4L12 12"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {!!props.cart.items.length && (
              <tfoot className="cart-footer">
                <tr className="cart-total">
                  <td colSpan="5" className="total-label">
                    <span>선택상품 합계</span>
                  </td>
                  <td colSpan="2" className="total-value">
                    <span className="total-amount">
                      {numberWithCommas(
                        props.cart.items
                          .filter(item => item.checked)
                          .reduce((accumulator, currentItem) => {
                            return (
                              accumulator + currentItem.quantity * currentItem.product_price.price
                            );
                          }, 0),
                      )}
                      원
                    </span>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>

        {/* 모바일 카드 레이아웃 */}
        <div className="cart-mobile-container mobile-only">
          {!props.cart.items.length ? (
            <div className="empty-cart-mobile">
              <p>장바구니에 상품이 하나도 없습니다.</p>
            </div>
          ) : (
            props.cart.items.map((item, index) => (
              <div key={item.id} className="cart-item-card">
                <div className="cart-item-header">
                  <label className="item-checkbox" htmlFor={`mobile-item-checkbox-${index}`}>
                    <input
                      id={`mobile-item-checkbox-${index}`}
                      name="isGoing"
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => props.updateCheckedCart(index)}
                    />
                    <span className="checkmark"></span>
                  </label>

                  <div className="product-info-compact">
                    <div className="product-name-line">
                      {item.product ? (
                        <a
                          onClick={() => props.goProduct(item.product.id)}
                          className="cart-item-name-link product-name-compact"
                        >
                          {item.product.name}
                        </a>
                      ) : (
                        <span className="deleted-product product-name-compact">삭제된 상품</span>
                      )}
                    </div>
                    <div className="product-details-line">
                      {item.product_price && (
                        <React.Fragment>
                          <span className="catalog-number">{item.product_price.part_number}</span>
                          <span className="unit-info">{item.product_price.unit}</span>
                        </React.Fragment>
                      )}
                    </div>
                  </div>

                  <button
                    className="delete-cart-item-mobile"
                    onClick={() => props.deleteItemCart(item.id)}
                    type="button"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M12 4L4 12M4 4L12 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <div className="cart-item-content">
                  <div className="product-image-mobile">
                    <a
                      onClick={() => props.goProduct(item.product.id)}
                      className="cart-item-name-link"
                    >
                      <img
                        src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                        className="cart-item-thumbnail-mobile"
                        alt="thumbnail"
                      />
                    </a>
                  </div>

                  <div className="product-info-mobile">
                    <div className="product-details-mobile">
                      {item.product_price && (
                        <div className="detail-item-mobile">
                          <span className="detail-value">{item.product_price.description}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="cart-item-pricing-mobile">
                  <div className="price-section-mobile">
                    {/* <div className="unit-price-mobile">
                      <span className="price-label">단가</span>
                      {item.price ? (
                        <div className="price-value">
                          <span className="sale-price">{numberWithCommas(item.price.sale.raw)}원</span>
                          {item.price.sale.raw !== item.price.original.raw && (
                            <span className="compare-price">
                              {numberWithCommas(item.price.original.raw)}원
                            </span>
                          )}
                        </div>
                      ) : (
                        <span className="sale-price">
                          {numberWithCommas(item.product_price.price)}원
                        </span>
                      )}
                    </div> */}

                    <div className="quantity-section-mobile">
                      <span className="quantity-label">수량</span>
                      <div className="quantity-control-mobile">
                        <button
                          type="button"
                          className="quantity-btn minus"
                          onClick={() => {
                            if (item.quantity > 1) {
                              const event = { target: { value: item.quantity - 1 } };
                              props.updateItemCart(index, item.id, event);
                            }
                          }}
                          disabled={item.quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none">
                            <path d="M0 1H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                        <input
                          name="itemQuantity"
                          min="1"
                          onChange={event => props.updateItemCart(index, item.id, event)}
                          value={item.quantity}
                          className="quantity-input-mobile"
                          required
                          type="text"
                          pattern="[1-9]*"
                        />
                        <button
                          type="button"
                          className="quantity-btn plus"
                          onClick={() => {
                            const event = { target: { value: item.quantity + 1 } };
                            props.updateItemCart(index, item.id, event);
                          }}
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M6 0V12M0 6H12" stroke="currentColor" strokeWidth="2" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div className="total-price-mobile">
                      <span className="total-label">가격</span>
                      <div className="total-value">
                        {item.product_price.price !== item.product_price.original_price && (
                          <span className="total-compare-price">
                            {numberWithCommas(item.quantity * item.product_price.original_price)}원
                          </span>
                        )}
                        <span className="total-amount">
                          {numberWithCommas(item.quantity * item.product_price.price)}원
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}

          {/* 모바일 합계 */}
          {!!props.cart.items.length && (
            <div className="cart-actions-mobile">
              <div className="cart-total-mobile">
                <span className="total-label-mobile">선택상품 합계</span>
                <span className="total-amount-mobile">
                  {numberWithCommas(
                    props.cart.items
                      .filter(item => item.checked)
                      .reduce((accumulator, currentItem) => {
                        return accumulator + currentItem.quantity * currentItem.product_price.price;
                      }, 0),
                  )}
                  원
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="checkout-section">
          <div className="checkout-actions">
            <div className="checkout-left-buttons">
              <Button
                color="gray"
                theme="outline"
                className="checkout-offer-btn"
                onClick={props.onOffer}
              >
                견적서 생성
              </Button>
            </div>
            <div className="checkout-right-buttons">
              {/* <Button color="gray" theme="outline" className="checkout-continue-btn" onClick={props.onShopping} >
                쇼핑 계속하기
              </Button> */}
              <Button className="checkout-order-btn" onClick={props.onOrder}>
                주문하기
              </Button>
            </div>
          </div>
        </div>

        {/* 모바일 전용 고정 하단 주문하기 버튼 */}
        <div className="mobile-fixed-checkout mobile-only">
          <div className="mobile-checkout-content">
            <div className="mobile-total-info">
              <span className="mobile-total-label">총 주문금액</span>
              <span className="mobile-total-price">
                {numberWithCommas(
                  props.cart.items
                    .filter(item => item.checked)
                    .reduce((accumulator, currentItem) => {
                      return accumulator + currentItem.quantity * currentItem.product_price.price;
                    }, 0),
                )}
                원
              </span>
            </div>
            <Button className="mobile-order-btn" onClick={props.onOrder}>
              주문하기
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CartTemplate;



// WEBPACK FOOTER //
// ./src/components/cart/CartTemplate/CartTemplate.js